import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { config, ShortUrl } from "@air/api";
import { matchesAirror, MISSING_OR_INVALID_SHORT_URL_PASSCODE } from "@air/errors";
import { Button } from "@air/primitive-button";
import { useToasts } from "@air/provider-toast";
import { Form, Formik } from "formik";
import * as Yup from "yup";
import PasswordInput from "~/components/Form/PasswordInput";
import { PASSCODE_PROTECTED_SHARE_PAGE_INPUT, SEND_PASSCODE_BUTTON } from "~/constants/testIDs";
import { reportErrorToBugsnag } from "~/utils/ErrorUtils";
const PasscodeFormSchema = Yup.object().shape({
    password: Yup.string().default("").required("Passcode is required.")
}).required();
const initialValues = PasscodeFormSchema.cast({});
export const PasswordPageInput = (param)=>{
    let { shortId, onVerified } = param;
    const { showToast } = useToasts();
    const submitPasscode = async (param, param1)=>{
        let { password } = param, { resetForm, setSubmitting } = param1;
        try {
            const token = await ShortUrl.verifyShortUrl(shortId, password);
            config.setShortUrlToken(shortId, token.id);
            await onVerified();
        } catch (error) {
            if (matchesAirror(error, MISSING_OR_INVALID_SHORT_URL_PASSCODE)) {
                showToast("Incorrect passcode, please try again.");
            } else {
                showToast("Something went wrong, please try again.");
                reportErrorToBugsnag({
                    error,
                    context: "Failed to submit passcode"
                });
            }
            setSubmitting(false);
            resetForm();
        }
    };
    return /*#__PURE__*/ _jsx("div", {
        className: "relative",
        children: /*#__PURE__*/ _jsx(Formik, {
            onSubmit: submitPasscode,
            initialValues: initialValues,
            validationSchema: PasscodeFormSchema,
            render: (param)=>{
                let { values, isSubmitting } = param;
                return /*#__PURE__*/ _jsxs(Form, {
                    className: "flex flex-col gap-6",
                    children: [
                        /*#__PURE__*/ _jsx(PasswordInput, {
                            size: "large",
                            testId: PASSCODE_PROTECTED_SHARE_PAGE_INPUT
                        }),
                        /*#__PURE__*/ _jsx(Button, {
                            className: "w-full",
                            "data-testid": SEND_PASSCODE_BUTTON,
                            disabled: !values.password,
                            isLoading: isSubmitting,
                            size: "large",
                            type: "submit",
                            children: "Submit"
                        })
                    ]
                });
            }
        })
    });
};
PasswordPageInput.displayName = "PasswordPageInput";
